import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router/index'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    uname: '',
    share_uname: '',
     //判断是否为生产环境
    // jwt_token: process.env.NODE_ENV == 'development' ? "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.IntcInVuaW9uSWRcIjpcIm9MZ19Ndzl0aVl1VUFOUnB2SWZSVFlHVVNaV0lcIixcInVpZFwiOjgxMjcsXCJsb2dpbl90aW1lXCI6MTU1OTYxNjk3Mn0i.AlqztUcFxoV9m2qv6Nx7vx7hPLAfeoQc3GNUrFz3SQU" : "",
    jwt_token: "",
    img_url: process.env.NODE_ENV == 'development' ? "http://mu.eguowang.com" : window.location.origin,
    // 菜单开启开关
    menu_open_status: {
      ifopen_ask: 0, //问答开启
      ifopen_quesiton: 1, //题库开启
    },
    is_iphoneX: false, //判断是否为iphonex
    userbing_phoneStatus: false, //是否需要绑定手机号
    // socket_live: 'wss://kxm.grazy.cn/wss',
  },
  mutations: {
    // 用户登录成功，存储 token
    logined(state, obj) {
      state.jwt_token = obj.jwt_token;
      state.uname = obj.uname;
      if(obj.tiku === 0){
        state.menu_open_status.ifopen_quesiton = 0
      }else{
        state.menu_open_status.ifopen_quesiton = 1
      }
    },
    //token失效， 清除token
    refreshToken(state, obj) {
      state.jwt_token = '';
      state.uname = '';
      state.share_uname = '';
    },
    //更新uname
    refreshShareUname(state, obj) {
      state.share_uname = obj;
    },
    //获取本地缓存token
    getLocalToken(state, obj) {
      state.jwt_token = obj;
    },
    // 更新菜单开启状态
    refreshMenuOpenStatus(state, obj) {
      state.menu_open_status = obj;
    },
    // 更新菜单开启状态
    refreshBindPhoneStatus(state, obj) {
      state.userbing_phoneStatus = obj;
    },
    // 判断是否为iphoneX
    is_iphoneX(state, obj) {
      state.is_iphoneX = obj
    }

  },
  actions: {
    //判断登录
    isLogin({
      dispatch,
      commit
    }, obj) {
      const that = this
      return new Promise(function (resolve, reject) {
        // console.log('判断登录' + window.localStorage.getItem('jwt_token'))
        //判断是否为生产环境
        // if (process.env.NODE_ENV == 'production') {
        // if (process.env.NODE_ENV == 'development') {
          if (window.localStorage.getItem('jwt_token') == null || window.localStorage.getItem('uname') == null) {
            // window.location.href = 'http://mu.eguowang.com/api3/login/authorize'
            return false;
          }
        // }
      })
    },
    //token失效 清除token
    refreshToken({
      dispatch,
      commit
    }, obj) {
      return new Promise(function (resolve, reject) {
        window.localStorage.removeItem('jwt_token');
        window.localStorage.removeItem('uname');
        window.localStorage.removeItem('tiku');
        commit('refreshToken');
        dispatch('isLogin')
      })
    },
    // 登录成功后保存token
    logined({
      dispatch,
      commit
    }, obj) {
      return new Promise(function (resolve, reject) {
        var backUrl = window.localStorage.getItem('routePath');
        commit('logined', obj)
        console.log('登录成功', obj)
        window.localStorage.setItem('jwt_token', obj.jwt_token);
        window.localStorage.setItem('uname', obj.uname);
        window.localStorage.setItem('tiku', obj.tiku);
        // router.replace(backUrl)
      })
    },
    //设置分享uname
    refreshShareUname({
      dispatch,
      commit
    }, obj) {
      return new Promise(function (resolve, reject) {
        // alert('设置本地share_uname---' + obj)
        window.localStorage.setItem('share_uname', obj);
        // alert('设置成功后的本地share_uname---' + window.localStorage.getItem('share_uname'))
        commit('refreshShareUname', obj);
        dispatch('isLogin')
      })
    },
    //刷新获取本地缓存token
    getLocalToken({
      dispatch,
      commit
    }, obj) {
      return new Promise(function (resolve, reject) {
        commit('getLocalToken', obj)
      })
    },
    //更新菜单开启状态
    refreshMenuOpenStatus({
      dispatch,
      commit
    }, obj) {
      return new Promise(function (resolve, reject) {
        commit('refreshMenuOpenStatus', obj);
      })
    },
    //更新手机绑定状态
    refreshBindPhoneStatus({
      dispatch,
      commit
    }, obj) {
      return new Promise(function (resolve, reject) {
        commit('refreshBindPhoneStatus', obj);
      })
    },
    //判断是否为iphonex
    is_iphoneX({
      dispatch,
      commit
    }, obj) {
      return new Promise(function (resolve, reject) {
        // iPhone X、iPhone XS
        var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
        // iPhone XS Max
        var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
        // iPhone XR
        var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
        if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
          commit('is_iphoneX', true);
        } else {
          commit('is_iphoneX', false);
        }
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js